export const etEE = {
  app: {
    categories: {
      convectors: 'Konvektorid',
      decorative: 'Dekoratiivne',
      electric: 'Elektriline',
      panels: 'Paneelid',
      towel: 'Rätikukuivati',
    },
    categoryLabel: 'Kategooria',
    categoryPlaceholder: 'Valige kategooria',
    errorCategories: 'Kategooriate laadimine ebaõnnestus.',
    errorPanels: 'Radiaatorite laadimine ebaõnnestus.',
    loadingCategories: 'Kategooriate laadimine...',
    loadingPanels: 'Radiaatorite laadimine...',
    panelLabel: 'Radiaatorid',
    panelPlaceholder: 'Valige radiaator',
    titles: {
      convectors: 'Konvektorite kalkulaator',
      decorative: 'Disainradiaatorite kalkulaator',
      electric: 'Elektriradiaatorite kalkulaator',
      panels: 'Paneelradiaatorite kalkulaator',
      towel: 'Rätikukuivatite kalkulaator',
    },
  },
  calc: {
    actionButton: 'Kuva arvutatud tooted',
    boost: 'Boost-režiim',
    calculateRequiredButton: 'Arvuta soojusvajadus',
    calculating: 'Arvutamine...',
    comfort: 'Mugavusrežiim',
    downloadLabel: 'Laadi alla andmed ({count})',
    emptyResults: 'Tulemused puuduvad.',
    errorMatch: 'Tulemuste arvutamine ebaõnnestus.',
    errorTypes: 'Paneelimudelite laadimine ebaõnnestus.',
    flowTemp: 'Pealevool C°',
    height: 'Kõrgus',
    length: 'Pikkus',
    loadingTypes: 'Mudelite laadimine...',
    modeLabel: 'Režiim',
    modes: {
      cooling: 'Jahutus',
      heating: 'Küte',
    },
    radiatorType: 'Radiaatori tüüp',
    requiredWatts: 'Soojusvajadus (vatt)',
    resultsMessage: '{count} toodet valitud seadetega saadaval.',
    returnTemp: 'Tagasivool C°',
    roomTemp: 'Ruumitemperatuur C°',
    selectAllLabel: 'Vali kõik tooted',
    selectItemLabel: 'Vali toode allalaadimiseks',
    selectPanel: 'Valige radiaator arvutamiseks.',
    standby: 'Ooterežiim',
    tableHeaders: {
      calculatedWattage: 'Võimsus',
      co2Equivalent: 'CO2-ekvivalent kg materjali kohta',
      depth: 'Sügavus [mm]',
      description: 'Toote kirjeldus',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Kõrgus [mm]',
      itemId: 'Toote kood',
      length: 'Pikkus [mm]',
      waterContent: 'Veemaht',
      weight: 'Kaal',
    },
    title: 'Arvutused',
    tolerance: 'Tolerants',
    typeCooling: 'Jahutamine',
    typeGroupLabel: 'Tüüp',
    typeHeating: 'Küttamine',
  },
  existingRadiator: {
    description:
      'See kalkulaator on ainult informatiivne. Enne radiaatori ostmist konsulteerige alati professionaalse paigaldajaga täpse arvutuse saamiseks.',
    height: 'Radiaatori kõrgus',
    length: 'Radiaatori pikkus',
    resultLabelTemplate: 'Soojusvõimsuse vajadus, arvutatud süsteemi temperatuuriga {temp}',
    select: 'Vali',
    temperature: 'Süsteemitemperatuur',
    type: 'Radiaatori tüüp',
  },
  matrixCalc: {
    axisHeight: 'Kõrgus (mm)',
    axisLength: 'Pikkus (mm)',
    axisType: 'Tüüp',
    calculateButton: 'Calculate',
    displayLabel: 'Kuva',
    exportExcel: 'Ekspordi Excelina',
    exportPdf: 'Ekspordi PDF-ina',
    print: 'Prindi',
    hideOutOfRange: 'Peida vahemikust väljas olevad tooted',
    showAll: 'Näita kõiki',
    loading: 'Loading...',
    lockHeight: 'Kõrgus',
    lockLabel: 'Lukusta mõõde',
    lockLength: 'Pikkus',
    lockType: 'Tüüp',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Arvuta',
    clearButton: 'Puhasta',
    fields: {
      ceilingHeight: 'Lae kõrgus',
      doorInsulation: 'Ukse soojustus',
      floorInsulation: 'Põranda soojustus',
      glazingArea: 'Klaaspind',
      glazingMode: 'Klaaspind',
      glazingQuality: 'Klaasi kvaliteet',
      length: 'Pikkus',
      outerWalls: 'Välisseinad',
      projectedDesignTemp: 'Arvestuslik välistemperatuur',
      roofInsulation: 'Katuse soojustus',
      roomArea: 'Ruumipind',
      roomFloor: 'Korrus',
      roomInsulation: 'Ruumi soojustus',
      roomPreset: 'Ruumi tüüp',
      roomTemperature: 'Ruumitemperatuur',
      roomType: 'Ruumi tüüp',
      uncertaintyFactor: 'Ebakindlustegur',
      ventilation: 'Ventilatsiooni tase',
      wallInsulation: 'Seina soojustus',
      width: 'Laius',
      windConditions: 'Tuuleolud',
      windowInsulation: 'Akna soojustus',
    },
    intro: 'Arvutage ruumi soojuskadu, et valida õige toode Purmo kütteseadmete valikust.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Rohkem kui 20%',
        low: 'Vähem kui 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Üle 20%',
        below_10: 'Alla 10%',
        from_10_to_20: '10% kuni 20% vahel',
        no_windows: 'Aknad puuduvad',
      },
      insulationValue: {
        good: 'Hea',
        medium: 'Keskmine',
        poor: 'Kehv',
        very_good: 'Väga hea',
      },
      qualityValue: {
        modern_excellent: 'Energiasäästlikud, kolmekordse klaasiga aknad',
        modern_good: 'Kaasaegsed, tihedad, soojustusklaasiga',
        old_poor: 'Vanad, kulunud, mittetihedad',
        traditional_medium: 'Traditsioonilised heas seisukorras, lisatihedusega',
      },
      roomValue: {
        bathroom_24: 'Vannituba (24 C°)',
        bedroom_20: 'Magamistuba (20 C°)',
        garage_12: 'Garaaž (12 C°)',
        livingroom_22: 'Elutuba (22 C°)',
        storage_16: 'Ladu (16 C°)',
      },
      select: 'Vali',
      storeyValue: {
        ground_multi: 'Esimene korrus (mitmekorruseline maja)',
        ground_single: 'Esimene korrus (ühekorruseline maja)',
        interim: 'Vahekorrus',
        top_multi: 'Ülemine korrus (mitmekorruseline maja)',
      },
      temp: {
        climate_zone_1: 'DUT -12 C°',
        climate_zone_2: 'DUT -14 C°',
        climate_zone_3: 'DUT -16 C°',
        climate_zone_4: 'DUT -18 C°',
        climate_zone_5: 'DUT -20 C°',
        climate_zone_6: 'DUT -22 C°',
        climate_zone_7: 'DUT -24 C°',
        climate_zone_8: 'DUT -26 C°',
      },
      windInfluence: {
        normal: 'Normaalsed',
        strong: 'Ebasoodsad',
        weak: 'Soodsad',
      },
    },
    roomPresets: {
      bathroom: 'Vannituba',
      bedroom: 'Magamistuba',
      garage: 'Garaaž',
      kitchen: 'Köök',
      living: 'Elutuba',
      storage: 'Ladu',
    },
    sections: {
      dimensions: 'Ruumi mõõtmed',
      insulation: 'Soojustus',
      placement: 'Asukoht',
      result: 'Tulemused',
      temps: 'Temperatuurid',
      ventilation: 'Ventilatsioon',
    },
    title: 'Soojusvajaduse kalkulaator',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Kasuta',
  },
  slider: {
    from: 'Alates',
    to: 'Kuni',
    value: 'Väärtus',
  },
}
